import messages from './loader-translations';

export default {
    name: 'loader',
    i18n: {
        messages,
    },
    props: ['show'],
};



// WEBPACK FOOTER //
// ./src/shared/components/loader/loader.js